import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", {
    ref: "span",
    class: _normalizeClass([{
      sliding: _ctx.flyin && !_ctx.left,
      leftsliding: _ctx.flyin && _ctx.left,
      block: _ctx.block,
      'inline-block': !_ctx.block,
      'translate-x-2000px': !_ctx.left,
      '-translate-x-2000px': _ctx.left,
    }, "transform-gpu"])
  }, [
    _renderSlot(_ctx.$slots, "default", {}, undefined, true)
  ], 2))
}